import { useComposer } from '@liveblocks/react-ui/primitives'
import { AtSign } from 'lucide-react'

import { Button } from '@/components/lemmala-design-system/button/button'

export const MentionButton = () => {
  const { createMention } = useComposer()
  return (
    <Button
      type='button'
      variant='ghost'
      size='icon-sm'
      aria-label='Mention someone'
      onClick={createMention}
    >
      <AtSign className='size-4' />
    </Button>
  )
}
